/* ⋮ is a 24 px icon in a 32 px target on a fine pointer, 44 px on a coarse one (spec §6, WCAG 2.5.8) */
.trigger {
  min-width: 32px;
  min-height: 32px;
  color: var(--tuna-palette-text-secondary);
}

@media (pointer: coarse) {
  .trigger {
    min-width: 44px;
    min-height: 44px;
  }
}
